export default __webpack_public_path__ + "media/images/icons/icon_file_download.svg";